<template>
  <div class="mt-4 pr-0 pl-0 pt-2 border_all" style="border: thin solid rgba(0,0,0,.12)">
    <div class="ma-6">
      <v-toolbar elevation="0">
        <v-text-field flat solo clearable prepend-icon="search" placeholder="Type something" v-model="opsitable.search"
          hide-details class=""></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click.native="onClickAdd">Tambah</v-btn>
        <v-btn color="primary" class="ml-2" @click.native="getBrandGroups(opsitable)">Refresh</v-btn>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="brandgroups"
        :loading="loading"
        :options.sync="opsi"
        :search="search"
        :server-items-length="totalbrandgroup"
        :sort-by.sync="opsi.sortBy[0]"
        :sort-desc.sync="sortdes[0]"
        @update:options="getBrandGroups(opsitable)"
        >
        <template v-slot:item.status="{ item }">
        <div class="ma-4 text-xs-left">
          <v-chip
              :color="colorStatus(item.status)"
              small
              text-color="white">
            {{ statusText(item.status) }}
          </v-chip>
        </div>
      </template>
          <template v-slot:item.logo="{ item }">
            <v-img width="36" class="ma-4" :src="item.logo"></v-img>
          </template>
        <template v-slot:item.aksi="{ item }">
          <v-btn icon @click.native="onClickEdit(item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </div>
    <v-dialog v-model="dialogbrandgroup" max-width="600px">
      <v-card>
        <v-toolbar dense dark color="primary">
          <v-toolbar-title>{{ isnewbrandgroup ? 'Tambah Brand Group' : 'Edit Brand Group' }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon class="" dark @click="setdialogbrandgroup(false)">close</v-icon>
        </v-toolbar>
        <v-card-text class="mt-4">
            <v-col cols="12" lg="6">
            <div class="mt-5">
              <div class="">
                <ImgUpload v-on:upload="onUpload" label="Logo" :value="selectedbrandgroup.logo" v-model="selectedbrandgroup.logo"/>
              </div>
            </div>
          </v-col>
            <div class="mt-5">
              <v-autocomplete
                  label="Category"
                  item-text="name"
                  item-value="id"
                  v-model="selectedbrandgroup.categoryid"
                  :items="categories"
              ></v-autocomplete>
            </div>
          <v-text-field label="Nama Brand Group" v-model="selectedbrandgroup.name"></v-text-field>
          <v-switch v-model="statusSlider" inset label="Aktif">Aktif</v-switch>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn elevation="0" color="red darken-1" dark @click.native="setdialogbrandgroup(false)">Batal</v-btn>
          <v-btn elevation="0" color="primary darken-1" @click.native="simpan">Simpan</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ImgUpload from '@/components/ImgUpload'
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
export default {
  name: 'BrandGroup',
  components: { ImgUpload },
  data: () => ({
    search: '',
    sortdes: [true],
    opsitable: {
      search: '',
      itemsPerPage: 10,
      page: 1,
      status: '',
      sortBy: ['id']
    },
    headers: [
      { text: 'Id', value: 'id', width: '10' },
      {
        text: 'Logo',
        value: 'logo',
        width: '10'
      },
      { text: 'CID', value: 'categoryid', width: '10' },
      { text: 'BrandGroup', value: 'name' },
      { text: 'Status', value: 'status', width: '10' },
      { text: 'Aksi', value: 'aksi' }
    ]
  }),
  computed: {
    ...mapState('AdminProducts', ['categories', 'loading', 'dialogbrandgroup', 'brandgroups', 'totalbrandgroup', 'selectedbrandgroup', 'isnewbrandgroup']),
    opsi: {
      get () {
        return this.opsitable
      },
      set (val) {
        this.opsitable = val
      }
    },
    statusSlider: {
      get () {
        return parseInt(this.selectedbrandgroup.status) === 1
      },
      set (val) {
        if (val) {
          this.selectedbrandgroup.status = 1
        } else {
          this.selectedbrandgroup.status = 0
        }
      }
    }
  },
  methods: {
    ...mapActions('AdminProducts', ['getBrandGroups', 'setdialogbrandgroup', 'setselectedbrandgroup', 'setisnewbrandgroup', 'tambahbrandgroup', 'editbrandgroup']),
    onUpload (img) {
      console.log(img)
      this.$store.dispatch('AdminProducts/setselectedbrandgrouplogo', img, { root: true })
      this.selectedbrandgroup.logo = img
    },
    formatDate (value) {
      if (value) {
        return moment(value).format('DD/MM/YYYY HH:mm:ss')
      } else {
        return ''
      }
    },
    statusText (val) {
      if (parseInt(val) === 1) {
        return 'Aktif'
      } else {
        return 'Tidak Aktif'
      }
    },
    colorStatus (val) {
      if (parseInt(val) === 0) {
        return 'red'
      }
      if (parseInt(val) === 1) {
        return 'green'
      }
    },
    onClickEdit (item) {
      this.setselectedbrandgroup(item)
      this.setisnewbrandgroup(false)
      this.setdialogbrandgroup(true)
    },
    onClickAdd () {
      this.setselectedbrandgroup({
        id: 0,
        brandgroupname: '',
        status: 1
      })
      this.setisnewbrandgroup(true)
      this.setdialogbrandgroup(true)
    },
    simpan () {
      if (this.isnewbrandgroup) {
        this.tambahbrandgroup(this.selectedbrandgroup)
      } else {
        this.editbrandgroup(this.selectedbrandgroup)
      }
    }
  },
  mounted () {
    this.getBrandGroups(this.opsitable)
  }
}

</script>
